import { createSlice } from "@reduxjs/toolkit";

const currentDate = new Date();
const currentYear = currentDate.getFullYear();
const currentMonth = currentDate.getMonth() + 1;
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function generateYears() {
  const startYear = 2023;
  const years = [];
  for (let year = startYear; year <= currentYear; year++) {
    years.push({ label: year.toString(), value: year });
  }
  return years;
}

// GLOABL FILTERS PRESERVE
const initialGBFiltersState = {
  selectedGym: null,
  startAndEndDate: {
    startDate: null,
    endDate: null,
    selectedDates: null,
  },
  selectedYear: generateYears().find((year) => year.value === currentYear),
  selectedMonth: { label: monthNames[currentMonth - 1], value: currentMonth },
};

const filtersSlice = createSlice({
  name: "filters",
  initialState: initialGBFiltersState,
  reducers: {
    setSelectedGym: (state, action) => {
      state.selectedGym = action.payload;
    },
    setStartAndEndDate: (state, action) => {
      state.startAndEndDate = action.payload;
    },
    setSelectedYear: (state, action) => {
      state.selectedYear = action.payload;
    },
    setSelectedMonth: (state, action) => {
      state.selectedMonth = action.payload;
    },
  },
});

export const {
  setSelectedGym,
  setStartAndEndDate,
  setSelectedYear,
  setSelectedMonth,
} = filtersSlice.actions;
export default filtersSlice.reducer;
// export const selectSelectedYear = (state) => state.filters.selectedYear;

// ---------------------- GLOABL FILTERS PRESERVE --------------------------
